import { render, staticRenderFns } from "./docHeatWithValue.vue?vue&type=template&id=24cdc877"
import script from "./docHeatWithValue.vue?vue&type=script&lang=js"
export * from "./docHeatWithValue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports